module.exports = "<p>\r\n  account-contact-shipping-address-page works!\r\n</p>\r\n"